import { Button } from '@yeshuman/sdk'
import { toast } from 'sonner'

import { useGrantRecruiterClient, useRecruiterGrants } from '../../hooks/use-recruiter-clients'

export function EmployerRecruiterGrants() {
  const grants = useRecruiterGrants()
  const grant = useGrantRecruiterClient()
  const rows = grants.data ?? []
  if (grants.isLoading || grants.error || rows.length === 0) return null

  return (
    <section className="mt-8 space-y-3">
      <h2 className="text-lg font-semibold">Recruiter access</h2>
      <p className="text-sm text-muted-foreground">
        TalentCo can already work your jobs. Granting records that you approved the relationship.
      </p>
      <ul className="divide-y divide-border rounded-md border border-border">
        {rows.map((row) => (
          <li key={row.id ?? row.organisation_id} className="flex items-center justify-between gap-3 px-4 py-3">
            <span>
              {row.recruiter_email || row.organisation_name}
              <span className="ml-2 text-sm text-muted-foreground">
                {row.organisation_name}
                {' · '}
                {row.granted ? 'Granted' : 'Selected, not granted'}
              </span>
            </span>
            {row.granted || !row.id ? null : (
              <Button
                type="button"
                size="sm"
                variant="outline"
                disabled={grant.isPending}
                onClick={() =>
                  grant.mutate(row.id!, {
                    onSuccess: () => toast.success(`Granted recruiter access for ${row.organisation_name}`),
                    onError: (error) => {
                      toast.error(error instanceof Error ? error.message : 'Could not grant access')
                    },
                  })
                }
              >
                Grant
              </Button>
            )}
          </li>
        ))}
      </ul>
    </section>
  )
}
